export default __webpack_public_path__ + "static/media/favicon.17dd76e1.ico";